__turbopack_context__.v({
  "btn": "styles-module__pMsoQa__btn",
  "contact": "styles-module__pMsoQa__contact",
  "contactTitle": "styles-module__pMsoQa__contactTitle",
  "contacts": "styles-module__pMsoQa__contacts",
  "social": "styles-module__pMsoQa__social",
});
